import { configureStore } from "@reduxjs/toolkit";
import ProductDetailsSliceReducer from "./slices/ProductDetailsSlice";
import VideoSliceReducer from "./slices/VideoSlice";

export const store = configureStore({
  reducer: {
    ProductDetails: ProductDetailsSliceReducer,
    Video: VideoSliceReducer,
  },
});
